import { createSelector } from "reselect";
import * as helpers from "../helpers";
import { PRACTITIONER } from "../consts";
import { deepGet } from "../../../utils";
import { CSRF_TOKEN } from "../../../api/config";

const configSelector = state => state.config;
const bookingSelector = state => state.booking;
const appointmentSelector = state => state.appointment;
const dataSourceSelector = state => state.dataSource;

const getState = (config, booking, appointment, dataSource) => {
  let text = "";
  const { preSelectPractitioner, practitionerFirst, siteConsultTypes } = config;
  const { specialtyType, location } = appointment;
  const { practitioners, schedules } = dataSource;

  const isPhoneConsult = siteConsultTypes.some(
    type => type.siteId === location && type.consultType === 1
  );

  const practitionersFilteredBySpecialty = helpers.filterPractitionersBySpecialty(
    practitioners,
    specialtyType
  );

  const schedulesFilteredByLocation = helpers.filterSchedulesByLocation(
    schedules,
    location
  );

  const options = helpers
    .filterPractitionersBySchedules(
      practitionersFilteredBySpecialty,
      schedulesFilteredByLocation
    )
    .map(p => {
      return {
        ...p,
        imageSrc: `/${config.tenant}/api/appointmentbooking/Image?imageId=${p.imageId}&token=${CSRF_TOKEN}`
      };
    });

  const required = options.length !== 1;
  const value = required
    ? deepGet(appointment, [PRACTITIONER])
    : options[0].practitionerId;

  if (appointment.practitioner) {
    if (appointment.practitioner === "ANY") {
      text = "Any practitioner";
    } else {
      const practitioner = dataSource.practitioners.find(
        p => p.practitionerId === appointment.practitioner
      );
      if (practitioner) {
        text = `${practitioner.firstName} ${practitioner.lastName}`;
      }
    }
  }

  return {
    text,
    hintText: config.practitionerHintText,
    isOpen: booking.controlVisibility[PRACTITIONER],
    value,
    options,
    required,
    completed: booking.completedSteps.includes(PRACTITIONER),
    reload: booking.reload,
    autoSelectAny: preSelectPractitioner === "ANY",
    practitionerFirst,
    isPhoneConsult
  };
};

const practitionerSelector = createSelector(
  configSelector,
  bookingSelector,
  appointmentSelector,
  dataSourceSelector,
  getState
);

export { practitionerSelector };



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/selectors/practitionerSelector.js